import env from "../../../config/env";
import { AxiosInstance } from "axios";
import { action, makeAutoObservable } from "mobx";
import http from "../../../services/http";
import { ServiceResult } from "../../../types/general-types";
import {
  CheckBlockedUnblockVerificationCodeRequestDto,
  CheckVerificationCodeRequestDto,
  CheckVerificationCodeResponseDto,
  LoginRequestDto,
  LoginResponseDto,
  SendBlockedUnblockVerificationCodeRequestDto,
  SendVerificationCodeRequestDto,
  SendVerificationCodeResponseDto,
} from "./types";
import qs from "qs";
const { API_BASE_URL } = env;

class LoginStore {
  static readonly id: string = "LoginStore";

  get api(): AxiosInstance {
    http.defaults.baseURL = API_BASE_URL;
    return http;
  }

  constructor() {
    makeAutoObservable(this);
  }

  @action.bound async Login(params: LoginRequestDto) {
    const response: ServiceResult<LoginResponseDto> = await (
      await this.api.post(`/account/login`, params)
    ).data;
    return response;
  }

  @action.bound async SendVerificationCode(
    params: SendVerificationCodeRequestDto
  ) {
    const response: ServiceResult<SendVerificationCodeResponseDto> = await (
      await this.api.post(`/account/send-verification`, params)
    ).data;
    return response;
  }

  @action.bound async CheckVerificationCode(
    params: CheckVerificationCodeRequestDto
  ) {
    const response: ServiceResult<CheckVerificationCodeResponseDto> = await (
      await this.api.post(`/account/check-verification`, params)
    ).data;
    return response;
  }

  @action.bound async SendBlockedUnblockVerificationCode(
    params: SendBlockedUnblockVerificationCodeRequestDto
  ) {
    const response: ServiceResult<SendVerificationCodeResponseDto> = await (
      await this.api.post(`/account/send-blocked-unblock-verification`, params)
    ).data;
    return response;
  }

  @action.bound async CheckBlockedUnblockVerificationCode(
    params: CheckBlockedUnblockVerificationCodeRequestDto
  ) {
    const response: ServiceResult = await (
      await this.api.post(`/account/check-blocked-unblock-verification`, params)
    ).data;
    return response;
  }
}

export default LoginStore;
